<app-panel
  title="Raport stanu magazynowego"
  [banner]="banner">
  <div class="relative size-full bg-surface-100 ring-1 ring-surface-200 rounded-xl p-3">

    @if (reportOrchestrator.isLoading()) {
      <app-loading></app-loading>
    }

    <p-stepper [(value)]="activeStep" class="flex flex-col items-start justify-start h-full" [linear]="true">
      <p-step-list class="inline-flex items-center justify-center flex-shrink-0">
        <p-step [value]="1" class="flex flex-row flex-auto gap-2">
          <ng-template #content let-activateCallback="activateCallback" let-value="value">
            <button class="bg-transparent border-0 inline-flex flex-col gap-2" (click)="activateCallback()">
              <span class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                    [ngClass]="{'bg-primary text-primary-contrast border-primary': value <= activeStep, 'border-surface': value > activeStep}">
                    <ng-icon name="tablerTableColumn" size="1.75rem"></ng-icon>
              </span>
            </button>
          </ng-template>
        </p-step>
        <p-step [value]="2" class="flex flex-row flex-auto gap-2">
          <ng-template #content let-activateCallback="activateCallback" let-value="value">
            <button class="bg-transparent border-0 inline-flex flex-col gap-2" (click)="activateCallback()">
              <span class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                    pTooltip="Specyfikacja pojazdu" tooltipPosition="top"
                    [ngClass]="{'bg-primary text-primary-contrast border-primary': value <= activeStep, 'border-surface text-primary bg-surface-0': value > activeStep}">
                    <ng-icon name="tablerCar" size="1.75rem"></ng-icon>
              </span>
            </button>
          </ng-template>
        </p-step>
        <p-step [value]="3" class="flex flex-row flex-auto gap-2">
          <ng-template #content let-activateCallback="activateCallback" let-value="value">
            <button class="bg-transparent border-0 inline-flex flex-col gap-2" (click)="activateCallback()">
              <span class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                    [ngClass]="{'bg-primary text-primary-contrast border-primary': value <= activeStep, 'border-surface text-primary bg-surface-0': value > activeStep}">
                    <ng-icon name="tablerCalendarClock" size="1.75rem"></ng-icon>
              </span>
            </button>
          </ng-template>
        </p-step>
        <p-step [value]="4" class="flex flex-row flex-auto gap-2">
          <ng-template #content let-activateCallback="activateCallback" let-value="value">
            <button class="bg-transparent border-0 inline-flex flex-col gap-2" (click)="activateCallback()">
              <span class="rounded-full border-2 w-12 h-12 inline-flex items-center justify-center"
                    [ngClass]="{'bg-primary text-primary-contrast border-primary': value <= activeStep, 'border-surface text-primary bg-surface-0': value > activeStep}">
                <ng-icon name="tablerKey" size="1.75rem"></ng-icon>
              </span>
            </button>
          </ng-template>
        </p-step>
      </p-step-list>
      <p-step-panels class="bg-surface-0 ring-1 ring-surface-200 rounded-xl size-full overflow-hidden pr-2 py-2">
        <div class="size-full overflow-y-auto min-h-0 p-2">
          <form [formGroup]="form" (submit)="onSubmit()">
            <p-step-panel [value]="1">
              <ng-template #content let-activateCallback="activateCallback">
                <div class="size-full flex flex-col items-start justify-between"
                     formGroupName="reportSchemeSection">
                  <div class="size-full p-2 flex flex-col items-start justify-start gap-5">
                    <h3 class="text-xl text-surface-500">Struktura raportu</h3>

                    <div class="w-full">
                      <p-message [severity]="'info'" [icon]="'pi pi-info-circle'" size="small">
                        Filtruj strukturę raportu wybierając kolumny danych. Domyślnie wszystkie kolumny biorą udział w
                        raporcie.
                      </p-message>
                    </div>

                    @if ((reportOrchestrator.availableReportColumns$ | async)?.length) {
                      <div class="w-full h-auto inline-flex gap-2 flex-wrap">
                        @for (column of selectedReportColumns(); track column.name) {
                          <p-chip [label]="column.name" styleClass="text-xs px-2 p-1"/>
                        }
                      </div>
                    }

                    <app-multiselect-input
                      formControlName="selectedReportColumns"
                      placeholder="Struktura raportu"
                      [options]="reportOrchestrator.availableReportColumns$ | async"
                      [maxSelectedLabels]="0"
                      [selectedItemsLabel]="'Liczba wybranych kolumn: {0}'"
                      class="w-full">
                    </app-multiselect-input>

                    <div class="flex pt-6 justify-end w-full">

                      <p-button
                        [disabled]="!reportSchemeSection.valid"
                        rounded
                        label="Przejdź dalej"
                        icon="pi pi-arrow-right"
                        iconPos="right"
                        (onClick)="activateCallback(2)"/>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-step-panel>
            <p-step-panel [value]="2">
              <ng-template #content let-activateCallback="activateCallback">
                <div class="size-full flex flex-col items-start justify-between"
                     formGroupName="vehicleDetailsSection">
                  <div class="size-full p-2 flex flex-col items-start justify-start gap-5">
                    <h3 class="text-xl text-surface-500">Specyfikacje pojazdu</h3>


                    <div class="w-full">
                      <p-message [severity]="'info'" [icon]="'pi pi-info-circle'" size="small">
                        Wybierz specyfikacje pojazdów biorących udział w raporcie.
                      </p-message>
                    </div>

                    <div class="w-full h-auto py-2">
                      <app-multiselect-input
                        formControlName="categories"
                        label="Filtruj kategorie pojazdów"
                        labelMode="float"
                        [options]="reportOrchestrator.vehicleCategories$ | async"
                        display="chip"
                        [maxSelectedLabels]="5"
                        [selectedItemsLabel]="'Liczba wybranych kategorii: {0}'"
                        [showToggleAll]="false"
                        [showClear]="true"
                        class="w-full">
                      </app-multiselect-input>
                    </div>

                    <div class="w-full h-auto py-2">
                      <app-multiselect-input
                        formControlName="brands"
                        label="Filtruj marki pojazdów"
                        labelMode="float"
                        [options]="reportOrchestrator.vehicleBrands$ | async"
                        display="chip"
                        [maxSelectedLabels]="5"
                        [selectedItemsLabel]="'Liczba wybranych marek: {0}'"
                        [showToggleAll]="false"
                        [showClear]="true"
                        class="w-full">
                      </app-multiselect-input>
                    </div>

                    <div class="w-full h-auto py-2">
                      <app-multiselect-input
                        formControlName="models"
                        label="Filtruj modele pojazdów"
                        labelMode="float"
                        [disabled]="!(reportOrchestrator.vehicleModels$ | async)?.length"
                        [options]="reportOrchestrator.vehicleModels$ | async"
                        display="chip"
                        [maxSelectedLabels]="5"
                        [selectedItemsLabel]="'Liczba wybranych modeli: {0}'"
                        [showToggleAll]="false"
                        [showClear]="true"
                        [showLoading]="true"
                        class="w-full">
                      </app-multiselect-input>
                    </div>

                    <div class="w-full h-auto py-2">
                      <app-text-chip-input
                        formControlName="vins"
                        placeholder="Filtruj numery VIN">
                      </app-text-chip-input>
                    </div>

                    <div class="w-full h-auto py-2">
                      <app-text-chip-input
                        formControlName="registrationPlates"
                        placeholder="Filtruj numery rejestracyjne">
                      </app-text-chip-input>
                    </div>

                    <div class="w-full h-auto py-2">
                      <app-text-chip-input
                        formControlName="factoryNumbers"
                        placeholder="Filtruj numery fabryczne">
                      </app-text-chip-input>
                    </div>

                    <div class="w-full h-auto py-2">
                      <app-multiselect-input
                        formControlName="storages"
                        label="Filtruj miejsca magazynowania pojazdów"
                        labelMode="float"
                        [options]="reportOrchestrator.vehicleStorages$ | async"
                        display="chip"
                        [lazy]="true"
                        (onLoadMore)="reportOrchestrator.fetchVehicleStorages($event)"
                        [maxSelectedLabels]="5"
                        [selectedItemsLabel]="'Liczba wybranych e-magazynów: {0}'"
                        [showToggleAll]="false"
                        [showClear]="true"
                        [showLoading]="true"
                        class="w-full">
                      </app-multiselect-input>
                    </div>

                    <div class="w-full h-auto py-2">
                      <app-multiselect-input
                        formControlName="owners"
                        label="Filtruj po właścicielach pojazdu"
                        labelMode="float"
                        [options]="reportOrchestrator.vehicleOwners$ | async"
                        display="chip"
                        [lazy]="true"
                        [virtualScroll]="true"
                        (onLoadMore)="reportOrchestrator.fetchVehicleOwners($event)"
                        [maxSelectedLabels]="5"
                        [selectedItemsLabel]="'Liczba wybranych właścicieli: {0}'"
                        [showToggleAll]="false"
                        [showClear]="true"
                        [showLoading]="true"
                        class="w-full">
                      </app-multiselect-input>
                    </div>

                    <div class="w-full h-auto py-2">
                      <app-text-chip-input
                        formControlName="returningPersons"
                        placeholder="Filtruj po osobach zdających pojazd">
                      </app-text-chip-input>
                    </div>

                    <div class="w-full h-auto py-2">
                      <app-text-chip-input
                        formControlName="receivers"
                        placeholder="Filtruj po osobach z wydanymi pojazdami">
                      </app-text-chip-input>
                    </div>

                    <div class="inline-flex pt-6 justify-end w-full gap-2">
                      <p-button
                        severity="secondary"
                        rounded
                        label="Powrót"
                        icon="pi pi-arrow-left"
                        iconPos="left"
                        (onClick)="activateCallback(1)"/>
                      <p-button
                        [disabled]="!vehicleDetailsSection.valid"
                        rounded
                        label="Przejdź dalej"
                        icon="pi pi-arrow-right"
                        iconPos="right"
                        (onClick)="activateCallback(3)"/>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-step-panel>
            <p-step-panel [value]="3">
              <ng-template #content let-activateCallback="activateCallback">
                <div class="size-full flex flex-col items-start justify-between overflow-y-auto min-h-0"
                     formGroupName="vehicleTimetablesSection">
                  <div class="size-full p-2 flex flex-col items-start justify-start gap-5">
                    <h3 class="text-xl text-surface-500">Przedziały czasowe</h3>

                    <div class="w-full">
                      <p-message [severity]="'info'" [icon]="'pi pi-info-circle'" size="small">
                        Określ przedziały czasowe przyjęcia i odbioru pojazdów
                      </p-message>
                    </div>

                    <div class="w-full flex flex-col gap-2">
                      <div class="w-full h-auto py-2 flex flex-col gap-2">
                        <span>Filtruj zakres dat przyjęcia</span>
                        <div class="w-full inline-flex items-center gap-2">
                          <app-date-input
                            class="w-[300px]"
                            [showTime]="true"
                            [maxDate]="vehicleTimetablesSection.get('arrivalDateTo')?.value ?? null"
                            formControlName="arrivalDateFrom">
                          </app-date-input>
                          <span class="text-sm">-</span>
                          <app-date-input
                            class="w-[300px]"
                            [showTime]="true"
                            [untilNow]="true"
                            formControlName="arrivalDateTo">
                          </app-date-input>
                        </div>
                      </div>

                      <div class="w-full h-auto py-2 flex flex-col gap-2">
                        <span>Filtruj zakres dat wydania</span>
                        <div class="w-full inline-flex items-center gap-2">
                          <app-date-input
                            class="w-[300px]"
                            [showTime]="true"
                            [maxDate]="vehicleTimetablesSection.get('releaseDateTo')?.value ?? null"
                            formControlName="releaseDateFrom">
                          </app-date-input>
                          <span class="text-sm">-</span>
                          <app-date-input
                            class="w-[300px]"
                            [showTime]="true"
                            [untilNow]="true"
                            formControlName="releaseDateTo">
                          </app-date-input>
                        </div>
                      </div>
                    </div>

                    <div class="inline-flex pt-6 justify-end w-full gap-2">
                      <p-button
                        severity="secondary"
                        rounded
                        label="Powrót"
                        icon="pi pi-arrow-left"
                        iconPos="left"
                        (onClick)="activateCallback(1)"/>
                      <p-button
                        [disabled]="!vehicleTimetablesSection.valid"
                        rounded
                        label="Przejdź dalej"
                        icon="pi pi-arrow-right"
                        iconPos="right"
                        (onClick)="activateCallback(4)"/>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-step-panel>
            <p-step-panel [value]="4">
              <ng-template #content let-activateCallback="activateCallback">
                <div class="size-full flex flex-col items-start justify-between overflow-y-auto min-h-0"
                     formGroupName="vehicleDocumentSection">
                  <div class="size-full p-2 flex flex-col items-start justify-start gap-5">
                    <h3 class="text-xl text-surface-500">Dokumentacje pojazdów</h3>

                    <div class="w-full">
                      <p-message [severity]="'info'" [icon]="'pi pi-info-circle'" size="small">
                        Określ szczegóły dokumentacji pojazdów. Pola są opcjonalne.
                      </p-message>
                    </div>

                    <div class="w-full h-auto py-2">
                      <app-text-chip-input
                        formControlName="keyNumbers"
                        placeholder="Filtruj numerach kluczyków">
                      </app-text-chip-input>
                    </div>

                    <div class="w-full h-auto py-2">
                      <app-text-chip-input
                        formControlName="documentNumbers"
                        placeholder="Filtruj numerach dokumentów">
                      </app-text-chip-input>
                    </div>

                    <div class="w-full h-auto py-2">
                      <app-text-chip-input
                        formControlName="archiveNumbers"
                        placeholder="Filtruj numerach archiwalnych">
                      </app-text-chip-input>
                    </div>

                    <div class="inline-flex pt-6 justify-end w-full gap-2">
                      <p-button
                        severity="secondary"
                        rounded
                        label="Powrót"
                        icon="pi pi-arrow-left"
                        iconPos="left"
                        (onClick)="activateCallback(3)"/>
                      <p-button
                        [disabled]="!reportSchemeSection.valid"
                        [loading]="reportOrchestrator.isLoading()"
                        rounded
                        label="Generuj raport"
                        icon="pi pi-file-excel"
                        iconPos="right"
                        type="submit"/>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-step-panel>
          </form>
        </div>
      </p-step-panels>
    </p-stepper>
  </div>
</app-panel>
